const Role = {
  PortalAdmin: "portal-admin",
  Accounting: "accounting",
  StationCashier: "station-cashier",
  LubeServ: "lubeserv",
};

export { Role };
